import React, { createContext, useMemo, useState } from "react";
import auth from "../utils/auth";

const DEFAULT_STATE = {
    gatewayId: null,
    selectedDeviceProfileType: null,
    selectedImportVendor: null,
    deviceProfileId: null,
    selectedApplicationType: null,
    applicationId: null,
    deviceId: null,
    selectedRedirectType: null,
    redirectId: null,
};

export const LnsCadastroRapidoContext = createContext({
    ...DEFAULT_STATE,
    userInfo: null,
    configMe: {},
    setGatewayId: () => {},
    setSelectedDeviceProfileType: () => {},
    setSelectedImportVendor: () => {},
    setDeviceProfileId: () => {},
    setSelectedApplicationType: () => {},
    setApplicationId: () => {},
    setDeviceId: () => {},
    setSelectedRedirectType: () => {},
    setRedirectId: () => {},
    updateField: () => {},
    resetState: () => {},
});

export const LnsCadastroRapidoContextProvider = ({ children }) => {
    const userInfo = auth.getUserInfo();

    const configMe = {
        headers: {
            Authorization: "Bearer " + auth.getToken(),
        },
    };

    const [state, setState] = useState(DEFAULT_STATE);

    const setGatewayId = (gatewayId) => {
        setState((prev) => ({
            ...prev,
            gatewayId,
        }));
    };

    const setSelectedDeviceProfileType = (selectedDeviceProfileType) => {
        setState((prev) => ({
            ...prev,
            selectedDeviceProfileType,
        }));
    };

    const setSelectedImportVendor = (selectedImportVendor) => {
        setState((prev) => ({
            ...prev,
            selectedImportVendor,
        }));
    };

    const setDeviceProfileId = (deviceProfileId) => {
        setState((prev) => ({
            ...prev,
            deviceProfileId,
        }));
    };

    const setSelectedApplicationType = (selectedApplicationType) => {
        setState((prev) => ({
            ...prev,
            selectedApplicationType,
        }));
    };

    const setApplicationId = (applicationId) => {
        setState((prev) => ({
            ...prev,
            applicationId,
        }));
    };

    const setDeviceId = (deviceId) => {
        setState((prev) => ({
            ...prev,
            deviceId,
        }));
    };

    const setSelectedRedirectType = (selectedRedirectType) => {
        setState((prev) => ({
            ...prev,
            selectedRedirectType,
        }));
    };

     const setRedirectId = (redirectId) => {
        setState((prev) => ({
            ...prev,
            redirectId,
        }));
    };

    const updateField = (field, value) => {
        setState((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const resetState = () => {
        setState(DEFAULT_STATE);
    };

    const value = useMemo(
        () => ({
            ...state,
            userInfo,
            configMe,
            setGatewayId,
            setSelectedDeviceProfileType,
            setSelectedImportVendor,
            setDeviceProfileId,
            setSelectedApplicationType,
            setApplicationId,
            setDeviceId,
            setSelectedRedirectType,
            setRedirectId,
            updateField,
            resetState,
        }),
        [state]
    );

    return (
        <LnsCadastroRapidoContext.Provider value={value}>
            {children}
        </LnsCadastroRapidoContext.Provider>
    );
};